import { sharedState } from '../../framework/state';
import { getResourcesNew } from '../../framework/client/resource';

import { Customer } from '../../../common/application/model/Customer';
import { ApplicationResource } from '../../../common/application/enumeration/ApplicationResource';
import { VehicleContract } from '../../../common/application/model/VehicleContract';
import { P_PAGE_SIZE } from '../../../common/framework/constants';

export async function getAccessibleCustomers() {
    const parameters = new Map<string, any>([
        [P_PAGE_SIZE, '2000'],
    ]);

    if (sharedState.admin) {
        return await getResourcesNew<Customer>(ApplicationResource.CUSTOMER, 1, parameters);
    } else {
        parameters.set('id', sharedState.context.scopes.manager.customerId || []);
        if (sharedState.context.scopes.manager.customerId!!.length > 0) {
            return await getResourcesNew<Customer>(ApplicationResource.CUSTOMER, 1, parameters);
        } else {
            return [];
        }
    }
}

export async function getVehicleContracts(customerIds: string[]): Promise<VehicleContract[]> {
    const parameters = new Map<string, any>([[P_PAGE_SIZE, '2000']]);

    if (customerIds.length) {
        parameters.set('customerId', customerIds);

        return await getResourcesNew(ApplicationResource.VEHICLE_CONTRACT, 1, parameters);
    } else if (sharedState.admin) {
        return await getResourcesNew(ApplicationResource.VEHICLE_CONTRACT, 1, parameters);
    } else if (sharedState.context.scopes.manager.customerId!!.length > 0) {
        parameters.set('customerId', sharedState.context.scopes.manager.customerId);

        return await getResourcesNew(ApplicationResource.VEHICLE_CONTRACT, 1, parameters);
    } else {
        return [];
    }
}
